import React, { useState, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { isMobile } from 'react-device-detect';
import TimeTextField from '../../../../../../components/TextFields/TimeTextField';
import { makeStyles } from '@material-ui/core/styles';
import { __ } from '../../../../../../utils/i18n';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  row: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gridGap: theme.spacing(1),
  },
  time: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const WorkTime = ({ data, onChange }) => {
  const classes = useStyles();
  const [allWeekLong, setAllWeekLong] = useState(true);
  const initialWeekDays = {
    Saturday: ['00:00', '23:59'],
    Sunday: ['00:00', '23:59'],
    Monday: ['00:00', '23:59'],
    Tuesday: ['00:00', '23:59'],
    Wednesday: ['00:00', '23:59'],
    Thursday: ['00:00', '23:59'],
    Friday: ['00:00', '23:59'],
  };
  const [week, setWeek] = useState(initialWeekDays);

  const handleChangeAllWeekLong = () => {
    if (!allWeekLong) setWeek(initialWeekDays);
    setAllWeekLong((prev) => !prev);
  };
  const handleChangeAllWeekWorkTime = (e) => {
    const { value, name } = e.target;
    if (name === 'start') {
      setWeek({
        Sunday: [value, week.Sunday[1]],
        Monday: [value, week.Sunday[1]],
        Tuesday: [value, week.Sunday[1]],
        Wednesday: [value, week.Sunday[1]],
        Thursday: [value, week.Sunday[1]],
        Friday: [value, week.Sunday[1]],
        Saturday: [value, week.Sunday[1]],
      });
    }
    if (name === 'end') {
      setWeek({
        Sunday: [week.Sunday[0], value],
        Monday: [week.Sunday[0], value],
        Tuesday: [week.Sunday[0], value],
        Wednesday: [week.Sunday[0], value],
        Thursday: [week.Sunday[0], value],
        Friday: [week.Sunday[0], value],
        Saturday: [week.Sunday[0], value],
      });
    }
  };
  const handleChangeEachDayWorkTime = (e) => {
    const { value, name } = e.target;
    const splited = name.split('-');
    const day = splited[0];
    if (splited[1] === 'start') {
      setWeek({ ...week, [day]: [value, week[day][1]] });
    }
    if (splited[1] === 'end') {
      setWeek({ ...week, [day]: [week[day][0], value] });
    }
  };
  const isSameWorkTime = (week) => {
    var test = [];
    for (const day in week) {
      test = new Set([...test, ...week[day]]);
    }
    if ([...test].length !== 2) {
      setAllWeekLong(false);
    }
  };

  useEffect(() => {
    onChange(week);
  }, [week]);

  useEffect(() => {
    if (!data) return;
    if (JSON.stringify(week) === JSON.stringify(data)) return;
    setWeek(data);
    isSameWorkTime(data);
  }, [data]);

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <FormControlLabel
          control={
            <Checkbox
              checked={allWeekLong}
              onChange={handleChangeAllWeekLong}
              name="allWeekLong"
            />
          }
          label="کل هفته"
        />
        {allWeekLong && (
          <div className={classes.time}>
            <TimeTextField
              value={week?.Saturday?.[0] || '00:00'}
              label="از ساعت"
              size="medium"
              variant="outlined"
              name="start"
              onChange={handleChangeAllWeekWorkTime}
            />
            <TimeTextField
              value={week?.Saturday?.[1] || '23:59'}
              label="تا ساعت"
              size="medium"
              variant="outlined"
              name="end"
              onChange={handleChangeAllWeekWorkTime}
            />
          </div>
        )}
      </div>
      {!allWeekLong && (
        <>
          {Object.entries(week).map((day) => (
            <div className={classes.row} key={day[0]}>
              <div>{__(day[0])}</div>

              <div className={classes.time}>
                <TimeTextField
                  value={week?.[day[0]]?.[0] || '00:00'}
                  label="از ساعت"
                  size="medium"
                  variant="outlined"
                  name={`${day[0]}-start`}
                  onChange={handleChangeEachDayWorkTime}
                />
                <TimeTextField
                  value={week?.[day[0]]?.[1] || '23:59'}
                  label="تا ساعت"
                  size="medium"
                  variant="outlined"
                  name={`${day[0]}-end`}
                  onChange={handleChangeEachDayWorkTime}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default WorkTime;
